import { render } from "./RuiDashboard.vue?vue&type=template&id=66203dc4"
const script = {}
script.render = render

export default script